module.exports = __webpack_public_path__ + "img/35_12.be96360a.png";